import React, {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {AI_AGENT_MEDIA} from '../../constants';
import AiAgentMedia from '../aiAgentMedia/AiAgentMedia';
import * as css from './AiAgentEmptyState.css';

interface AiAgentEmptyStateProps {
    children: ReactNode;
}

function AiAgentEmptyState({children}: AiAgentEmptyStateProps) {
    const {t} = useTranslation('aiAgent');

    return (
        <css.emptyState>
            <css.emptyVideo>
                <AiAgentMedia src={AI_AGENT_MEDIA.empty.src} poster={AI_AGENT_MEDIA.empty.poster} />
            </css.emptyVideo>
            <css.emptyText>{t('emptyText')}</css.emptyText>
            <css.suggestionsWrap>{children}</css.suggestionsWrap>
        </css.emptyState>
    );
}

export default AiAgentEmptyState;
